'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = function (Component) {
  var ShareButtonDecorator = function (_React$Component) {
    _inherits(ShareButtonDecorator, _React$Component);

    function ShareButtonDecorator() {
      var _ref;

      _classCallCheck(this, ShareButtonDecorator);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var _this = _possibleConstructorReturn(this, (_ref = ShareButtonDecorator.__proto__ || Object.getPrototypeOf(ShareButtonDecorator)).call.apply(_ref, [this].concat(args)));

      _this._defaultButtonRef = { current: null };
      _this.focus = _this.focus.bind(_this);
      return _this;
    }

    _createClass(ShareButtonDecorator, [{
      key: 'focus',
      value: function focus() {
        if (this._wrappedInstance && typeof this._wrappedInstance.focus === 'function') {
          this._wrappedInstance.focus();
          return;
        }

        var buttonRef = this.props.buttonRef || this._defaultButtonRef;
        if (buttonRef.current && typeof buttonRef.current.focus === 'function') {
          buttonRef.current.focus();
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props = this.props,
            buttonRef = _props.buttonRef,
            rest = _objectWithoutProperties(_props, ['buttonRef']);

        return _react2.default.createElement(Component, _extends({}, rest, {
          buttonRef: buttonRef || this._defaultButtonRef,
          ref: function ref(wrappedInstance) {
            _this2._wrappedInstance = wrappedInstance;
            (0, _utils.copyMethods)(wrappedInstance, _this2);
          }
        }));
      }
    }]);

    return ShareButtonDecorator;
  }(_react2.default.Component);

  var componentName = (0, _reactUtils.getComponentName)(Component);
  ShareButtonDecorator.displayName = 'ShareButton(' + componentName + ')';
  ShareButtonDecorator.propTypes = _extends({}, Component.propTypes, {
    buttonRef: _refObject2.default
  });
  ShareButtonDecorator.defaultProps = Component.defaultProps;
  (0, _utils.attachWrappedComponent)(ShareButtonDecorator, Component);

  return ShareButtonDecorator;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _utils = require('./utils');

var _refObject = require('../utils/propTypes/refObject');

var _refObject2 = _interopRequireDefault(_refObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1282/js/decorators/ShareButton.js
// module id = 142
// module chunks = 0